 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"47a65e54be6c4db88ccb022b352d785c3c158b31","1":"61129e0199c105a365c07b6d68d69c974747e6e5","2":"styles","3":"374e4a017114f0a3dc9e514f7498f65ba8e7a695","4":"eab37c4c93088a6b4235e069e7c864e9f83bf728","5":"eb74cd0eebc8bd1cf6de9864d51c7836b24bb1a4","6":"framework","7":"1e4146758b4e14bdc1c7408f9feb05d712fcf0de","8":"8d47f31b147e25321f994441f71ba571dcf38ac3","9":"994c6225e76c371843b1e459cec4a4c0a2a67e2d","10":"5d564c221852c688eb0e38855a9bb3f240243b86","11":"0f7106e4636c39179bdca46b0242ae73d2d832f3","14":"ceb1012a","15":"component---src-pages-404-js","16":"component---src-pages-about-js","17":"component---src-pages-business-consent-processing-pd-js","18":"component---src-pages-careers-js","19":"component---src-pages-consent-processing-pd-js","20":"component---src-pages-contacts-js","21":"component---src-pages-dengiru-privacy-policy-js","22":"component---src-pages-faq-js","23":"component---src-pages-index-js","24":"component---src-pages-legal-2019-js","25":"component---src-pages-legal-2020-js","26":"component---src-pages-legal-2021-js","27":"component---src-pages-legal-2022-js","28":"component---src-pages-legal-2023-js","29":"component---src-pages-legal-2024-js","30":"component---src-pages-legal-2025-js","31":"component---src-pages-legal-bpa-js","32":"component---src-pages-legal-central-bank-license-js","33":"component---src-pages-legal-crs-compliance-js","34":"component---src-pages-legal-deposit-insurance-js","35":"component---src-pages-legal-fatca-compliance-js","36":"component---src-pages-legal-important-updates-js","37":"component---src-pages-legal-index-js","38":"component---src-pages-legal-info-rates-js","39":"component---src-pages-legal-list-insider-info-js","40":"component---src-pages-legal-ombudsman-js","41":"component---src-pages-legal-osms-2020-report-js","42":"component---src-pages-legal-pci-dss-certified-js","43":"component---src-pages-legal-pd-protection-js","44":"component---src-pages-legal-requisite-js","45":"component---src-pages-lp-card-acquiring-js","46":"component---src-pages-money-transfer-js","47":"component---src-pages-pricing-js","48":"component---src-pages-products-account-js","49":"component---src-pages-products-escrow-account-js","50":"component---src-pages-products-marketplaces-js","51":"component---src-pages-products-online-banking-js","52":"component---src-pages-products-payment-bot-js","53":"component---src-pages-products-payments-js","54":"component---src-pages-products-payouts-js","55":"component---src-pages-products-sbp-js","56":"component---src-pages-rules-documents-dengi-ru-credit-orgs-js","57":"component---src-pages-rules-documents-dengi-ru-index-js","58":"component---src-pages-rules-documents-dengi-ru-registration-js","59":"component---src-pages-rules-documents-dengi-ru-rules-js","60":"component---src-pages-self-employed-js","61":"component---src-pages-terms-of-use-terms-of-use-bank-cards-js","62":"component---src-templates-blog-js","63":"component---src-templates-post-js"}[chunkId]||chunkId) + "-" + {"0":"7db934a1a52c9dfdec07","1":"a8c0cbc35ced82292d26","2":"2d82ac8e3afc0c213061","3":"4b52aa8454ba83a8be8c","4":"e591ba262c6e7fd7ac78","5":"09ffbf9a3787670da34a","6":"2009307bf8387ff66401","7":"efec767c900edb221c7c","8":"86af430e8d374a6acd50","9":"ccddc484c257c5483f45","10":"058fbe34f3f70b7efe7e","11":"8cfcefd11aa31c8ad5f0","14":"204e4a16004021f6dbb8","15":"bf83230ac0108cf3aceb","16":"c3f72a3b870209404e7c","17":"05d4a23863ff73b76a43","18":"d33f769be17abf2953bc","19":"a5657f8cc93a369195a4","20":"dc2f329c214844ef0267","21":"f4d180c4f0e4d320caa3","22":"2e0c92b97bec18bd6b2a","23":"9183b66a5ed6c1097e50","24":"d2214bc781821fc643e8","25":"1476040f3b732d4b1ea8","26":"c26480f677cd45afc60b","27":"12717f558071ff017f6d","28":"58197e8f9f201fc45a09","29":"d2d202d6f1431f0672ff","30":"60261888ed8f019e7e85","31":"a738a87693b5b37f7805","32":"cd040aff6388eb94aa95","33":"74a6c64965be4fa89e35","34":"720fe53a13d2cd182973","35":"4ea85677d29cde74c6a7","36":"3b75a21d3cb3d8a10e9f","37":"a395dc784db015e74c23","38":"0277c1da3d0201df8cd3","39":"bc26d0a30b5c0227d830","40":"1303fadb199f70410d66","41":"4c6c31ca3b5daf16b1a6","42":"4a391a71e8dab3747291","43":"b60a8e67d027d28199d7","44":"8ca6499a15557fc59f9d","45":"f2ae23559af3b95d6d7e","46":"87c6d181f004fc5642f5","47":"166e0137a9a16f53007b","48":"af0a6ac3829ced07e3b5","49":"b28d67b46cf77e9819df","50":"74b6b666894c7c4728d0","51":"5d86bf3c0b4e3eed2576","52":"ad185a84a9124d08d27e","53":"d5389b59a650d430097d","54":"14eab55ff8713cf0ca5f","55":"21b7e561c4a6570949ec","56":"0fa90267d3841c3a5a0d","57":"da52c324d3c3f0ed370f","58":"195def2dcc3e2b306d30","59":"b272ba4cfd614f6f5e79","60":"522bd573811f6525e2f2","61":"f3d0024494e05e5d9b35","62":"90068950cad5086a8c6e","63":"4c8c1b154a4b9e274d95"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"47a65e54be6c4db88ccb022b352d785c3c158b31","1":"61129e0199c105a365c07b6d68d69c974747e6e5","2":"styles","3":"374e4a017114f0a3dc9e514f7498f65ba8e7a695","4":"eab37c4c93088a6b4235e069e7c864e9f83bf728","5":"eb74cd0eebc8bd1cf6de9864d51c7836b24bb1a4","6":"framework","7":"1e4146758b4e14bdc1c7408f9feb05d712fcf0de","8":"8d47f31b147e25321f994441f71ba571dcf38ac3","9":"994c6225e76c371843b1e459cec4a4c0a2a67e2d","10":"5d564c221852c688eb0e38855a9bb3f240243b86","11":"0f7106e4636c39179bdca46b0242ae73d2d832f3","14":"ceb1012a","15":"component---src-pages-404-js","16":"component---src-pages-about-js","17":"component---src-pages-business-consent-processing-pd-js","18":"component---src-pages-careers-js","19":"component---src-pages-consent-processing-pd-js","20":"component---src-pages-contacts-js","21":"component---src-pages-dengiru-privacy-policy-js","22":"component---src-pages-faq-js","23":"component---src-pages-index-js","24":"component---src-pages-legal-2019-js","25":"component---src-pages-legal-2020-js","26":"component---src-pages-legal-2021-js","27":"component---src-pages-legal-2022-js","28":"component---src-pages-legal-2023-js","29":"component---src-pages-legal-2024-js","30":"component---src-pages-legal-2025-js","31":"component---src-pages-legal-bpa-js","32":"component---src-pages-legal-central-bank-license-js","33":"component---src-pages-legal-crs-compliance-js","34":"component---src-pages-legal-deposit-insurance-js","35":"component---src-pages-legal-fatca-compliance-js","36":"component---src-pages-legal-important-updates-js","37":"component---src-pages-legal-index-js","38":"component---src-pages-legal-info-rates-js","39":"component---src-pages-legal-list-insider-info-js","40":"component---src-pages-legal-ombudsman-js","41":"component---src-pages-legal-osms-2020-report-js","42":"component---src-pages-legal-pci-dss-certified-js","43":"component---src-pages-legal-pd-protection-js","44":"component---src-pages-legal-requisite-js","45":"component---src-pages-lp-card-acquiring-js","46":"component---src-pages-money-transfer-js","47":"component---src-pages-pricing-js","48":"component---src-pages-products-account-js","49":"component---src-pages-products-escrow-account-js","50":"component---src-pages-products-marketplaces-js","51":"component---src-pages-products-online-banking-js","52":"component---src-pages-products-payment-bot-js","53":"component---src-pages-products-payments-js","54":"component---src-pages-products-payouts-js","55":"component---src-pages-products-sbp-js","56":"component---src-pages-rules-documents-dengi-ru-credit-orgs-js","57":"component---src-pages-rules-documents-dengi-ru-index-js","58":"component---src-pages-rules-documents-dengi-ru-registration-js","59":"component---src-pages-rules-documents-dengi-ru-rules-js","60":"component---src-pages-self-employed-js","61":"component---src-pages-terms-of-use-terms-of-use-bank-cards-js","62":"component---src-templates-blog-js","63":"component---src-templates-post-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"1480866c74f4b930f714","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
